export default __webpack_public_path__ + "static/media/addistweet.2e780175.PNG";